import AppConfig from '@/AppConfig';
// Classes
import Race from '@/classes/race';
import League from '@/classes/league';
import Profile from '@/classes/profile';
import Country from '@/classes/country';
import Driver from '@/classes/driver';
import Team from '@/classes/team';
import LeagueTeam from '@/classes/leagueTeam';

// Countries and State
import States from '@/data/states.json';
import Countries from '@/data/countries.json';

// These Two are the same?
// TODO: Pick one
import Standings from '@/classes/standings';
import LeagueRaceResults from '@/classes/leagueRaceResults';

// Modules
import IMSAPI from '@/modules/ims-service/ims-api';
import tick from '@/modules/tick/tick';

import Member from '@/classes/member';
import LeagueStanding from '@/classes/leagueStanding';

export default class IMSData {
    public api: IMSAPI;

    constructor() {
        this.api = new IMSAPI();
    }

    /**
     * Get All Available races
     */
    public async getRaces(): Promise<Array<Race>> {
        // Get from service
        let races: Array<Race> = await this.api.get('races');
        // If we
        if (races) {
            races = races.map((race: any) => {
                return new Race(race);
            });
        }
        return races || [];
    }

    public async getDrivers(raceId: number): Promise<Array<Driver>> {
        let allDrivers = await this.api.get(`drivers`);
        let raceDrivers = await this.api.get(`race/${raceId}/drivers`);
        if (raceDrivers && allDrivers) {
            let drivers = raceDrivers
                .filter((rd: any) => {
                    return (rd.raceId = raceId);
                })
                .map((rd: any) => {
                    let found = allDrivers.find((driver: any) => {
                        return driver.id == rd.driverId;
                    });
                    if (found) {
                        let driver: Driver = new Driver(found);
                        driver.value = rd.cost;
                        driver.raceDriverId = rd.id;
                        driver.racePoints = rd.racePoints;
                        driver.totalPoints = rd.totalPoints;
                        return driver;
                    } else {
                        return null;
                    }
                })
                .filter((driver: any) => {
                    return driver !== null;
                });
            return drivers;
        } else {
            return [];
        }
    }

    public async getRaceLeagueStandings(
        raceId: Number,
        leagueId: Number
    ): Promise<any> {
        let standings = await this.api.get(
            `/leagues/details?limit=3&top=50&raceId=${raceId}&leagueId=${leagueId}`
        );
        if (standings) {
            let payload = {
                aroundMe: standings.leagueDetails.map((ld: any) => {
                    // TODO - change to Standings
                    return new LeagueRaceResults(ld);
                }),
                top: standings.leagueTopDetails.map((ld: any) => {
                    // TODO - change to Standings
                    return new LeagueRaceResults(ld);
                })
            };
            return payload;
        }
    }

    /**
     * Overall Standings
     * @param leagueId
     */
    public async getLeagueOverallStandings(leagueId: Number): Promise<any> {
        let standings = await this.api.get(
            `leagues/allRacesDetails?leagueId=${leagueId}&limit=3&top=50`
        );
        if (standings) {
            let payload = {
                aroundMe: standings.leagueAllRacesDetails.map((ld: any) => {
                    return new LeagueRaceResults(ld);
                }),
                top: standings.leagueAllRacesTopDetails.map((ld: any) => {
                    return new LeagueRaceResults(ld);
                })
            };
            return payload;
        }
    }

    public async getRace(id: number): Promise<any> {
        let response = await this.api.get(`races/${id}`);
        if (response) {
            return new Race(response);
        } else {
            return false;
        }
    }

    /**
     * Get Public Leagues
     */
    public async getPublicLeagues(): Promise<Array<League>> {
        let leagues = await this.api.get('leagues/available');
        if (leagues) {
            return leagues.map((league: any) => {
                return new League(league);
            });
        } else {
            return [];
        }
    }
    /**
     * Get My Leages
     */
    public async getMyLeagues() {
        try {
            let standings = await this.api.get('leagues/standings');
            // let myLeagues = await this.api.get('leagues/available');

            if (standings) {
                return standings
                    .map((standings: any) => {
                        return new LeagueStanding(standings);
                    })
                    .sort((a: LeagueStanding, b: LeagueStanding) => {
                        return a.leagueName > b.leagueName ? 1 : -1;
                    });
                // .filter((leagueStanding: LeagueStanding) => {
                //   return myLeagues.find(
                //     (l: League) => (l.id = leagueStanding.leagueId)
                //   );
                // });
            } else {
                return [];
            }
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    public async getLeagueMembers(leagueId: any) {
        try {
            let response = await this.api.get(`leagues/${leagueId}/members`);
            return response.map((member: any) => {
                return new Member(member);
            });
        } catch (e) {
            throw e;
        }
    }

    public async inviteToLeague(email: string, leagueId: number) {
        try {
            let response = await this.api.post(`leagues/invite`, {
                emailAddress: email,
                leagueId
            });
            if (response) {
                return response;
            } else {
                return false;
            }
        } catch (e) {
            //alert(`Sorry, invitation failed. Error: ${e.message}`);
            //return false;
            throw e;
        }
    }

    public async changeLeagueName(id: number, name: string) {
        try {
            let response = await this.api.put(`leagues`, {
                id,
                name
            });
            if (response) {
                return response;
            } else {
                return false;
            }
        } catch (e) {
            alert(`Sorry, you can't rename this League. Do you have permissions?`);
            return false;
        }
    }

    /**
     * User Profile Work
     */

    public async getProfile() {
        // Set profile to be null
        let profile = null;
        try {
            // try to get it
            profile = await this.api.get('users/me');
            if (profile) {
                return new Profile(profile);
            } else {
                return null;
            }
        } catch (e) {
            if (e.message.search('401') > -1) {
                console.log('Authorization error');
                throw e;
            } else {
                throw e;
            }
        }
    }

    public async saveProfile(profile: Profile): Promise<any> {
        try {
            let response = await this.api.post('users', profile);
            if (response) {
                return response;
            } else {
                return false;
            }
        } catch (e) {
            throw e;
        }
    }

    public async getLeague(leagueId: any): Promise<any> {
        try {
            let leagueResponse = await this.api.get(`leagues/${leagueId}`);
            if (leagueResponse) {
                return new League(leagueResponse);
            } else {
                return null;
            }
        } catch (e) {
            throw e;
        }
    }

    /**
     * Get League Standings
     * Returns standings for races
     * and an overall standing
     * @param leagueId
     */
    public async getLeagueStandings(leagueId: any): Promise<any> {
        try {
            let response = await this.api.get(
                `leagues/raceStandings?leagueId=${leagueId}`
            );
            if (response) {
                // If it comes back null - which it might in a new database
                // we need to not create a standing - this way the frontend
                // can know not to show anything.
                const overall = response.leagueAllRacesStanding
                    ? new Standings(response.leagueAllRacesStanding)
                    : null;

                const standings = response.leagueRaceStandings.map((res: any) => {
                    return new Standings(res);
                });
                return { standings, overall };
            } else {
                return null;
            }
        } catch (e) {
            throw e;
        }
    }

    // Leagues
    public async joinPublicLeague(league: League) {
        try {
            let response = await this.api.post(
                `userLeagues/league/${league.id}`,
                null
            );
            if (response) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            throw e;
        }
    }

    public async createLeague(league: League): Promise<any> {
        try {
            let response = await this.api.post('leagues', league);
            return response;
        } catch (e) {
            throw e;
        }
    }

    public async leaveLeague(leagueId: number) {
        return await this.api.delete(`userLeagues?leagueId=${leagueId}`, null);
    }

    public async removeFromLeague(leagueId: number, member: Member) {
        return await this.api.delete(`leagues/invite`, {
            leagueId: leagueId,
            emailAddress: member.emailAddress,
            userId: member.userId
        });
    }

    public async getCountries(): Promise<Array<Country>> {
        // let countries = await this.api.get('countries');
        // countries = countries || [];
        return Countries.sort((a: any, b: any) => {
            return a.name > b.name ? 1 : -1;
        });
    }

    public async getStates(countryCode: any): Promise<Array<any>> {
        return this.api.get('states');
    }
    /** Get a User from league's Team for a specific race */
    public async getDifferentUserTeam(raceId: number, userId: string): Promise<LeagueTeam> {
        try {
            let team = await this.api.get(`teams/user/${userId}/race/${raceId}`);
            if (Array.isArray(team) && team.length == 0) {
                return new LeagueTeam({
                    raceId: raceId
                });
            } else {
                return new LeagueTeam(team);
            }
        } catch (e) {
            throw e;
        }
    }
    /** Get a Users Team for a specific race */
    public async getTeam(raceId: number): Promise<Team> {
        try {
            let team = await this.api.get(`teams?raceId=${raceId}`);
            if (Array.isArray(team) && team.length == 0) {
                return new Team({
                    raceId: raceId
                });
            } else {
                return new Team(team[0]);
            }
        } catch (e) {
            throw e;
        }
    }

    public async saveTeam(raceId: number, team: Team): Promise<any> {
        try {
            team.raceId = raceId;
            // Prepare Response
            let response;
            // Determine POST (insert) or PUT (update)
            if (team.id) {
                response = await this.api.put('teams', team.toPayload());
            } else {
                response = await this.api.post('teams', team.toPayload());
            }
            // If we got a response
            if (response) {
                // Return new Team
                return new Team(response);
            } else {
                return false;
            }
        } catch (e) {
            throw e;
        }
    }
}
